/**
 * /state-tax is a legacy URL: one hop to the State filings landing. The old
 * /state-tax/annual-report, /franchise-tax, /$id, /success and /cancel routes
 * redirect the same way (single hop each).
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/state-tax/')({
  beforeLoad: () => {
    throw redirect({ to: '/state-filings', replace: true })
  },
})
